<div class="common-dialog">
  <h2 mat-dialog-title>{{ title }}</h2>

  <mat-dialog-content class="mat-typography">
    <mat-form-field *ngIf="isSearchNotImported()" class="search-container">
      <mat-label>ランテス番号で検索</mat-label>
      <input matInput type="text" [(ngModel)]="runtesId" (keyup.enter)="search()">
    </mat-form-field>

    <mat-form-field *ngIf="isSearchTotalRaceId()" class="search-container">
      <mat-label>TotalRaceIdで検索</mat-label>
      <input matInput type="text" [(ngModel)]="totalRaceId" (keyup.enter)="search()">
    </mat-form-field>
    <mat-form-field *ngIf="isSearchMoshicom()" class="search-container">
      <mat-label>e-moshicomイベントIDで検索</mat-label>
      <input matInput type="text" [(ngModel)]="moshicomRaceId" (keyup.enter)="search()">
    </mat-form-field>

    <div class="table-container">
      <table mat-table [dataSource]="races" class="common-table mat-elevation-z8">

        <ng-container matColumnDef="id">
          <ng-container *ngIf="isSearchNotImported()">
            <th mat-header-cell *matHeaderCellDef>RUNNET大会ID</th>
            <td mat-cell *matCellDef="let race">{{ race.runnet_race_id }}</td>
          </ng-container>
          <ng-container *ngIf="isSearchTotalRaceId()">
            <th mat-header-cell *matHeaderCellDef>TotalRaceId</th>
            <td mat-cell *matCellDef="let race">{{ race.runnet_total_race_code }}</td>
          </ng-container>
          <ng-container *ngIf="isSearchMoshicom()">
            <th mat-header-cell *matHeaderCellDef>e-moshicomイベントID</th>
            <td mat-cell *matCellDef="let race">{{ race.moshicom_race_id }}</td>
          </ng-container>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>大会名</th>
          <td mat-cell *matCellDef="let race">{{ race.title }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let race; columns: displayedColumns;" (click)="onClickRace(race)"></tr>
      </table>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button mat-dialog-close>閉じる</button>
  </mat-dialog-actions>
</div>
